// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!../_base.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Guest access — tavern theme */

.guest-access-page {
  padding: var(--space-4);
  max-width: 960px;
  margin: 0 auto;
}

.guest-access-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--space-3);
  margin-bottom: var(--space-4);
}

.guest-access-back {
  background: none;
  border: 1px solid var(--color-wood-500);
  border-radius: var(--radius-lg);
  color: var(--color-wood-700);
  padding: var(--space-2) var(--space-3);
  font-family: var(--font-body);
  cursor: pointer;
}

.guest-access-content {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.guest-access-section-title {
  margin-top: var(--space-4);
  font-family: var(--font-heading);
  font-weight: var(--font-weight-bold);
  color: var(--color-wood-700);
}

.guest-access-card {
  background: rgba(245, 239, 231, 0.9);
  border: 2px solid var(--color-success-500);
  border-radius: var(--radius-lg);
  padding: var(--space-4);
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.guest-access-card--finished {
  border-color: var(--color-wood-500);
  opacity: 0.7;
}

.guest-access-card__head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--space-3);
}

.guest-access-card__day {
  font-family: var(--font-heading);
  font-size: 18px;
  font-weight: var(--font-weight-bold);
  color: var(--color-fire-600);
}

.guest-access-card__time {
  margin-top: var(--space-1);
  color: var(--color-wood-700);
  font-weight: var(--font-weight-semibold);
}

.guest-access-card__actions {
  display: flex;
  gap: var(--space-2);
}

.guest-access-icon {
  background: none;
  border: 1px solid var(--color-wood-500);
  border-radius: var(--radius-md);
  padding: var(--space-2);
  font-size: 16px;
  line-height: 1;
  cursor: pointer;
}

.guest-access-card__tables {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-2);
}

.guest-access-chip {
  display: inline-flex;
  flex-direction: column;
  align-items: flex-start;
  padding: var(--space-1) var(--space-3);
  border-radius: var(--radius-md);
  background: rgba(76, 175, 80, 0.2);
  border: 1px solid var(--color-success-500);
  font-weight: var(--font-weight-semibold);
  color: var(--color-wood-700);
}

.guest-access-chip small {
  font-weight: normal;
  font-size: 11px;
  opacity: 0.8;
}

.guest-access-card__meta {
  display: flex;
  gap: var(--space-4);
  flex-wrap: wrap;
  font-size: 13px;
  color: var(--color-wood-600);
}

/* Form */

.guest-access-form-group {
  margin-bottom: var(--space-3);
}

.guest-access-form-group__title {
  font-weight: var(--font-weight-bold);
  color: var(--color-wood-700);
  margin-bottom: var(--space-2);
}

.guest-access-form-check {
  display: flex;
  align-items: center;
  gap: var(--space-2);
  padding: var(--space-2) 0;
  color: var(--color-wood-700);
}

.guest-access-form-check--disabled {
  opacity: 0.5;
}
`, "",{"version":3,"sources":["webpack://./src/pages/GuestAccess/GuestAccessPage.css"],"names":[],"mappings":"AAEA,gCAAgC;;AAEhC;EACE,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,+BAA+B;EAC/B,4BAA4B;EAC5B,sCAAsC;EACtC,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,+BAA+B;EAC/B,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,eAAe;EACf,oCAAoC;EACpC,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,sCAAsC;EACtC,+BAA+B;EAC/B,kCAAkC;EAClC,0CAA0C;EAC1C,wCAAwC;EACxC,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,4BAA4B;AAC9B;;AAEA,SAAS;;AAET;EACE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,4BAA4B;EAC5B,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd","sourcesContent":["@import '../_base.css';\n\n/* Guest access — tavern theme */\n\n.guest-access-page {\n  padding: var(--space-4);\n  max-width: 960px;\n  margin: 0 auto;\n}\n\n.guest-access-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n  margin-bottom: var(--space-4);\n}\n\n.guest-access-back {\n  background: none;\n  border: 1px solid var(--color-wood-500);\n  border-radius: var(--radius-lg);\n  color: var(--color-wood-700);\n  padding: var(--space-2) var(--space-3);\n  font-family: var(--font-body);\n  cursor: pointer;\n}\n\n.guest-access-content {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n.guest-access-section-title {\n  margin-top: var(--space-4);\n  font-family: var(--font-heading);\n  font-weight: var(--font-weight-bold);\n  color: var(--color-wood-700);\n}\n\n.guest-access-card {\n  background: rgba(245, 239, 231, 0.9);\n  border: 2px solid var(--color-success-500);\n  border-radius: var(--radius-lg);\n  padding: var(--space-4);\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-3);\n}\n\n.guest-access-card--finished {\n  border-color: var(--color-wood-500);\n  opacity: 0.7;\n}\n\n.guest-access-card__head {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: var(--space-3);\n}\n\n.guest-access-card__day {\n  font-family: var(--font-heading);\n  font-size: 18px;\n  font-weight: var(--font-weight-bold);\n  color: var(--color-fire-600);\n}\n\n.guest-access-card__time {\n  margin-top: var(--space-1);\n  color: var(--color-wood-700);\n  font-weight: var(--font-weight-semibold);\n}\n\n.guest-access-card__actions {\n  display: flex;\n  gap: var(--space-2);\n}\n\n.guest-access-icon {\n  background: none;\n  border: 1px solid var(--color-wood-500);\n  border-radius: var(--radius-md);\n  padding: var(--space-2);\n  font-size: 16px;\n  line-height: 1;\n  cursor: pointer;\n}\n\n.guest-access-card__tables {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-2);\n}\n\n.guest-access-chip {\n  display: inline-flex;\n  flex-direction: column;\n  align-items: flex-start;\n  padding: var(--space-1) var(--space-3);\n  border-radius: var(--radius-md);\n  background: rgba(76, 175, 80, 0.2);\n  border: 1px solid var(--color-success-500);\n  font-weight: var(--font-weight-semibold);\n  color: var(--color-wood-700);\n}\n\n.guest-access-chip small {\n  font-weight: normal;\n  font-size: 11px;\n  opacity: 0.8;\n}\n\n.guest-access-card__meta {\n  display: flex;\n  gap: var(--space-4);\n  flex-wrap: wrap;\n  font-size: 13px;\n  color: var(--color-wood-600);\n}\n\n/* Form */\n\n.guest-access-form-group {\n  margin-bottom: var(--space-3);\n}\n\n.guest-access-form-group__title {\n  font-weight: var(--font-weight-bold);\n  color: var(--color-wood-700);\n  margin-bottom: var(--space-2);\n}\n\n.guest-access-form-check {\n  display: flex;\n  align-items: center;\n  gap: var(--space-2);\n  padding: var(--space-2) 0;\n  color: var(--color-wood-700);\n}\n\n.guest-access-form-check--disabled {\n  opacity: 0.5;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
